import styled from 'styled-components';
import { Card, StyledButton } from '../main/CommonStyles';

export const BookingLayout = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    gap: ${({ theme }) => theme.spacing.lg};

    @media (min-width: 1200px) {
        /* Układ 3-kolumnowy */
        grid-template-columns: 2fr 1.2fr 1.2fr;
        align-items: flex-start;
    }
`;

export const CalendarSection = styled(Card)`
    h3 {
        font-size: 1.25rem;
        font-weight: 600;
        color: ${({ theme }) => theme.colors.primaryDark};
        margin-bottom: ${({ theme }) => theme.spacing.md};
    }

    .react-calendar {
        width: 100%;
        border: none;
        font-family: ${({ theme }) => theme.fonts.main};
    }

    .react-calendar__navigation button {
        color: ${({ theme }) => theme.colors.primary};
        min-width: 44px;
        background: none;
        font-size: 1rem;
        font-weight: 600;
    }
    .react-calendar__navigation button:enabled:hover,
    .react-calendar__navigation button:enabled:focus {
        background-color: ${({ theme }) => theme.colors.primaryLightest};
    }
    .react-calendar__month-view__weekdays__weekday {
        text-align: center;
        font-weight: 500;
        font-size: 0.75rem;
        color: ${({ theme }) => theme.colors.textMedium};
        abbr { text-decoration: none; }
    }
    .react-calendar__tile {
        background: none;
        text-align: center;
        line-height: 2rem;
        font-size: 0.875rem;
        border-radius: ${({ theme }) => theme.borderRadius};
        transition: background-color 0.2s, color 0.2s;
        height: 48px;
    }
    .react-calendar__tile:enabled:hover,
    .react-calendar__tile:enabled:focus {
        background-color: ${({ theme }) => theme.colors.primaryLightest};
        color: ${({ theme }) => theme.colors.primaryDark};
    }
    .react-calendar__tile--now {
        background: ${({ theme }) => theme.colors.secondaryLight + '4D'};
        color: ${({ theme }) => theme.colors.secondaryDark};
        font-weight: 600;
    }
    .react-calendar__tile--active {
        background: ${({ theme }) => theme.colors.primary};
        color: white;
        font-weight: 600;
    }
    .react-calendar__tile--active:enabled:hover,
    .react-calendar__tile--active:enabled:focus {
        background: ${({ theme }) => theme.colors.primaryDark};
    }
    .react-calendar__tile:disabled {
        background-color: #f1f5f9;
        color: #94a3b8;
        text-decoration: line-through;
        opacity: 0.7;
    }
`;

export const TimeSlotsSection = styled(Card)`
    h3 {
        font-size: 1.25rem;
        font-weight: 600;
        color: ${({ theme }) => theme.colors.primaryDark};
        margin-bottom: ${({ theme }) => theme.spacing.md};
    }
    .no-slots {
        color: ${({ theme }) => theme.colors.textDisabled};
        font-style: italic;
        text-align: center;
        padding: 2rem 0;
    }
`;

export const TimeSlotButton = styled.button`
    width: 100%;
    padding: ${({ theme }) => theme.spacing.sm} ${({ theme }) => theme.spacing.md};
    margin-bottom: ${({ theme }) => theme.spacing.sm};
    border: 1px solid ${({ theme, $selected }) => $selected ? theme.colors.primary : theme.colors.borderColor};
    background-color: ${({ theme, $selected }) => $selected ? theme.colors.primaryLightest : theme.colors.white};
    color: ${({ theme, $selected }) => $selected ? theme.colors.primaryDark : theme.colors.textDark};
    border-radius: ${({ theme }) => theme.borderRadius};
    cursor: pointer;
    text-align: center;
    font-weight: 600;
    transition: all 0.2s ease-in-out;
    font-size: 0.95rem;

    display: flex;
    justify-content: space-between;
    align-items: center;

    .slot-type-icon {
        color: ${({ theme }) => theme.colors.textMedium};
    }

    &:hover:not(:disabled) {
        border-color: ${({ theme }) => theme.colors.primary};
        background-color: ${({ theme }) => theme.colors.primaryLightest};
    }

    &:disabled {
        background-color: ${({ theme }) => theme.colors.neutralLight};
        color: ${({ theme }) => theme.colors.textDisabled};
        cursor: not-allowed;
        border-color: ${({ theme }) => theme.colors.borderColor};
        text-decoration: line-through;
    }
`;

export const ConfirmationSection = styled(Card)`
    margin-top: 0; 
    height: 100%;
    display: flex;
    flex-direction: column;

    h3 {
        font-size: 1.25rem;
        font-weight: 600;
        color: ${({ theme }) => theme.colors.primaryDark};
        margin-bottom: ${({ theme }) => theme.spacing.md};
    }
    
    textarea {
        width: 100%;
        min-height: 120px;
        flex-grow: 1; /* Rozciągnij pole tekstowe */
        padding: ${({ theme }) => theme.spacing.sm};
        border-radius: ${({ theme }) => theme.borderRadius};
        border: 1px solid ${({ theme }) => theme.colors.borderColor};
        font-family: inherit;
        font-size: 0.95rem;
        margin-bottom: 1rem;
        resize: vertical;
    }
`;

export const ConfirmBookingButton = styled(StyledButton)`
    width: 100%;
    margin-top: auto; /* Wypchnij przycisk na dół */
`;

export const PsychologistSelector = styled.div`
    margin-bottom: ${({ theme }) => theme.spacing.lg};
    label {
        display: block;
        margin-bottom: ${({ theme }) => theme.spacing.xs};
        font-weight: 600;
        color: ${({ theme }) => theme.colors.textDark};
        font-size: 1.1rem;
    }
    select {
        width: 100%;
        max-width: 500px;
        padding: ${({ theme }) => theme.spacing.md};
        border: 1px solid ${({ theme }) => theme.colors.borderColor};
        border-radius: ${({ theme }) => theme.borderRadius};
        font-family: ${({ theme }) => theme.fonts.main};
        font-size: 1rem;
        background-color: ${({ theme }) => theme.colors.white};
    }
`;